<div class="auth-page-content">
    <a class="logo" [routerLink]="['/']"><img [src]="logoUrl()" alt="logo"></a>
    <div class="auth-panel">
        <ng-content></ng-content>
    </div>
    
</div>
<div class="custom-menu-container">
    <a href="https://boons.io/" class="copyright font-16 dark-mode">© 2023 | {{settings.get('branding.site_name')}} | All Rights Reserved </a>
    <custom-menu position="auth-page-footer" [horizontal]="true"></custom-menu>
</div>
